import React, { useEffect } from 'react';
import { Container, Row, Col } from 'react-bootstrap';

import Header from '../../components/Header';
import Footer from '../../components/Footer';

import '../../assets/styles/globals.css';
import './styles.css';

import pmsGraphImg from '../../assets/images/pms_graph.png';
import pms2Img from '../../assets/images/pms2.jpg';


function PMS() {
  useEffect(() => {
    window.scrollTo({
      top: 0,
      left: 0,
    })
  }, [])
  
  return (
    <>
      <Header />
      <div className="background-pms">
        <div className="bg-pms"></div>
        <div className="container">
          <div className="banner-pms content-pms">
            <h1>PMS</h1>
            <p>Performance Monitoring System</p>
           </div>
        </div>
      </div>

      <div className="container">
        <div className="content gap-40 section-title">
          <h1>PMS</h1>
          <p className="pms-text">
          Eólica Tecnologia has a Vibration-based Condition Monitoring System (CMS) on all wind turbines. 
          The targets of the system are reduction of maintenance costs, increase of availability, avoidance of unplanned downtimes, improvement of quality & reliability and extend wind turbine’s lifetime.
          </p>
        </div>
      </div>

      <div className="container">
        <div className="content">
          <div className="pms-highlights">
            <Container>
              <Row>
                <Col xs={12} md={12} sm={12} lg={6} ><img src={pmsGraphImg} alt="WindIntelli"/></Col>
                <Col xs={12} md={12} sm={12} lg={6} className="col-pms-highlights">
                  <p>
                    Maintenance contracts often include availability as its key performance indicator. 
                    A drawback to this approach is that it does not reflect how well the wind turbine performs. 
                    It is common to rely almost exclusively in the intuition of the wind farm operator to elaborate the maintenance planning. 
                    In reality, plenty of factors (such as the expected production, wind turbine failure, etc.) often have a negative effect in the availability of the wind farm and additional maintenance costs occurs.
                  </p>
                </Col>
              </Row>
            </Container>
          </div>  
        </div>
      </div>

      <div className="container">
        <div className="content">
          <div className="pms-highlights">
            <Container>
              <Row>
                <Col xs={12} md={12} sm={12} lg={6} className="col-pms-highlights">
                  <p>
                  Eólica Tecnologia developed the Performance Monitoring System (PMS) as an effort to optimize the production and reduce O&M costs of its own wind farms. 
                  Data from the Supervisory Control and Data Acquisition (SCADA) system (which records every possible operational characteristic of the wind turbines) is used as input to the performance monitoring solution. 
                  The data analysis of our PMS system is able to capture the true state of each wind turbine and detect performance issues, which in turn are readily informed to O&M manager that ensures their correction.
                  </p>
                </Col>
                <Col xs={12} md={12} sm={12} lg={6} ><img src={pms2Img} alt="WindIntelli"/></Col>
              </Row>
            </Container>
          </div>  
        </div>
      </div>

        <Footer />
    </>
  )
}

export default PMS;